import React, { useState, useRef, useEffect } from "react";
import { Header } from "../components/Common/Header";

import BgImage from "../assets/images/Headers/Question.jfif";

export const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

 useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const faqList = [
    {
      question: "What do I need to get started with the ICF certification?",
      answer:
        "You don’t need any prior coaching experience! All you need is a passion for helping others and a desire to grow. Whether you’re looking to level up your career, explore a new path, or start a business, our program will guide you every step of the way.",
    },
    {
      question: "Will this certification really help me find clients?",
      answer:
        "Yes, absolutely! ICF is the gold standard in coaching certification, recognized worldwide for its professionalism and ethics. When you’re ICF-certified, you will stand out from other coaches. Clients trust ICF-certified coaches because they know you’ve been trained to the highest international standards. The demand for skilled coaches is booming, and an ICF certification is the key to unlocking opportunities for clients who seek the best. When clients see that you are ICF certified, it gives them the confidence that you are not just another coach they can trust you to help them reach their goals.",
    },
    {
      question: "Do I need a background in coaching to get started?",
      answer:
        "Not at all! The ICF certification is designed for beginners and experienced coaches alike. Whether you’re just starting out or already have some experience, our training will elevate your skills to a global standard. You'll gain knowledge that will help you become an exceptional coach, no matter where you’re starting from",
    },
    {
      question: "Why is the ICF certification important?",
      answer:
        "This is where trust comes in. Clients will only invest in your coaching if they trust you—and that trust is built on your credibility, skills, and professionalism. An ICF-certified coach is globally recognized as a professional who follows the highest ethical standards and uses proven techniques to deliver real results. Think of it as a seal of approval. When you get certified, you’re not just learning to be a coach; you’re building a reputation that will open doors to clients and opportunities. Without ICF certification, you risk being just another coach in a crowded market. With it, you’ll have the trust and recognition you need to rise above the rest.",
    },
    {
      question: "How does ICF certification impact my career?",
      answer:
        `ICF certification is not just a piece of paper; it’s an investment in your future. Here’s how it will change your life: 
        \n1. Increase Your Earning Potential: Coaches with ICF certification typically earn more because they are trusted to deliver results.
        \n2. More Opportunities: With over 59,000 ICF-certified coaches in 158 countries, you’ll have access to a global network of potential clients, employers, and business partners.
        \n3. Build Your Reputation: ICF-certified coaches are highly regarded in the industry. This credential will give you instant credibility and respect from clients and colleagues alike
        \n4. Flexible Work Life: With your ICF certification, you can work from anywhere, at any time. This flexibility means you can design a career that works for you, not the other way around.` 
      },
    {
      question: "Why should I choose ICF over other certifications?",
      answer:
        "This is critical. ICF is the most trusted and recognized coaching certification in the world. It's not just about completing a course—it's about becoming part of a global network of professionals who are held to the highest ethical and coaching standards. When you’re ICF certified, you’re not just learning techniques. You’re becoming part of an elite group that clients trust to deliver results. Think about it: Would you hire a coach who isn’t ICF-certified or one who has gone through the most rigorous training in the industry? Being ICF-certified matters because trust is everything in coaching. Without it, you’ll constantly struggle to differentiate yourself in a crowded market. With it, your opportunities to succeed, grow, and make an impact are endless.",
    },
    {
      question: "Why is trust so important in coaching?",
      answer:
        "Trust is the foundation of any successful coaching relationship. Your clients are coming to you with personal, sometimes vulnerable challenges. They need to know that you are someone they can rely on, someone who will guide them with integrity, skills, and a proven track record. ICF certification instantly builds that trust because it’s a worldwide symbol of professionalism. Clients don’t just need a coach; they need someone they trust to help them navigate their biggest challenges. When you’re ICF certified, you show them that you’ve been rigorously trained and are committed to delivering results based on the highest standards of coaching practice. Without trust, coaching is just a conversation. With trust, it becomes a transformative experience. Get certified and become that trusted professional clients seek.",
    },
    {
      question: "What makes ICF-certified coaches stand out?",
      answer:
        `When you become ICF certified, you are demonstrating that you are among the best in the world. Here’s what sets ICF coaches apart: 
        \n1. Credibility: Clients know that ICF-certified coaches have met the highest standards in terms of ethics, professionalism, and competency. 
        \n2. Results: ICF coaches use proven techniques to deliver real, measurable outcomes for their clients. 
        \n3. Global Reach: With ICF certification, you gain access to clients from around the world, enabling you to work in different cultures and environments.`
    },
    {
      question: "How long does the ICF certification process take?",
      answer:
        "The ICF certification process typically takes 6-12 months, depending on the program you choose. You’ll undergo comprehensive training and practical coaching experience that will prepare you to meet the rigorous standards set by the ICF. It’s a high-quality investment in your career, and the results are worth it.",
    },
    {
      question: "Can I really work from anywhere once I’m ICF-certified?",
      answer:
        "Absolutely! One of the best things about being an ICF-certified coach is the freedom it provides. You can coach clients remotely, whether it’s over the phone, via video calls, or in-person when needed. You’re not tied to a desk or a location—you create your own coaching business on your terms.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <Header
        image={BgImage}
        title="FAQ"
      />
      <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
        {faqList.map((faq, index) => (
          <div
            key={index}
            style={{
              marginBottom: "30px",
              boxShadow: "0px 4px 20px 0px #00000010",
              borderRadius: "8px",
            }}
          >
            <div
              style={{
                padding: "30px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => toggleAccordion(index)}
            >
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  textAlign: "left",
                  lineHeight: "1.2", // Adjust line-height for readability
                }}
              >
                {faq.question}
              </p>

              <span
                style={{
                  transform:
                    activeIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/128/32/32195.png"
                  alt="arrow"
                  width={16}
                  height={16}
                />
              </span>
            </div>
            <div
              ref={(el) => (contentRefs.current[index] = el)}
              style={{
                maxHeight:
                  activeIndex === index
                    ? contentRefs.current[index]?.scrollHeight
                    : 0,
                overflow: "hidden",
                transition: "max-height 0.3s ease",
                backgroundColor: "#fff",
              }}
            >
              <div style={{ padding: "10px 30px 30px 30px" }}>
                <p
                  style={{
                    fontSize: "16px",
                    textAlign: "left",
                    lineHeight: "1.2", // Adjust line-height for readability
                    whiteSpace: "pre-wrap"
                  }}
                >
                  {faq.answer}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};